<template>
    <div>
        <div class="LogManagementMonitor-title">
            <div>{{ $t('alarms.logService.logService') }}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.logService.logService')">
                    <div class="LogManagementMonitor-top">
                        <log-management-search></log-management-search>
                    </div>
                    <table-log-management></table-log-management>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import LogManagementSearch from '../log_management/LogManagementSearch'
    import TableLogManagement from '../log_management/TableLogManagement'

    export default {
        name: 'LogManagementMonitor',
        components: {
            LogManagementSearch,
            TableLogManagement
        }
    }
</script>

<style scoped>
    .LogManagementMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .LogManagementMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .LogManagementMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/log_management/LogManagementMonitor.vue